import { useTranslation } from "react-i18next";

import useLeadStats from "../../../data/useLeadStats"
import apiConfig from "../../../utils/apiConfig";
import DashboardStat from "../../dashboard/DashboardStat"
import DashboardTile from "../../dashboard/DashboardTile"
import DashboardTileMultiple from "../../dashboard/DashboardTileMultiple";


export default function LeadStats() {
  const { t } = useTranslation("leads");
  const { leadStats } = useLeadStats("LeadStats");


  if (leadStats.isLoading || !leadStats.data?.data) return null;

  const stats = leadStats.data?.data;

  const tileClass = "min-w-48"

  return (
    <div className="flex gap-4 flex-wrap bg-white shadow rounded p-4">
      <DashboardStat title={stats.awaitingContact?.toString()} desc={t("Awaiting Contact")} color={"gray"} className={tileClass} />
      <DashboardStat title={stats.customerToCallBack?.toString()} desc={t("Customer To Call Back")} color={"teal"} className={tileClass} />
      <DashboardStat title={stats.scheduled?.toString()} desc={t("Scheduled")} color={"blue"} className={tileClass} />
      <DashboardStat title={stats.reschedule?.toString()} desc={t("Reschedule")} color={"yellow"} className={tileClass} />
      <DashboardTileMultiple values={[stats.collected?.toString(), stats.collectedToday?.toString()]} labels={[t("Collected"), t("Collected Today")]} subLabels={[]} colour="purple" className={tileClass} borderless />
      <DashboardStat title={stats.awaitingPayment?.toString()} desc={t("Awaiting Payment")} color={"pink"} className={tileClass} />
      <DashboardStat title={stats.awaitingCod?.toString()} desc={t("Awaiting COD")} color={"indigo"} className={tileClass} />
      <DashboardStat title={stats.cancelled?.toString()} desc={t("Cancelled")} color={"red"} className={tileClass} />
      <DashboardTileMultiple values={[stats.completed?.toString(), stats.completedToday?.toString()]} labels={[t("Completed"), t("Completed Today")]} subLabels={[]} colour="green" className={tileClass} borderless />
    </div>
  )
}